import { render, staticRenderFns } from "./ScoringRuleSection.vue?vue&type=template&id=52bb9195&scoped=true"
import script from "./ScoringRuleSection.vue?vue&type=script&lang=js"
export * from "./ScoringRuleSection.vue?vue&type=script&lang=js"
import style0 from "./ScoringRuleSection.vue?vue&type=style&index=0&id=52bb9195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb9195",
  null
  
)

export default component.exports